<template>
  <div>
    <div>gHello</div>
  </div>
</template>

<script>
export default {
  name: "GHello",
  props: {

  },
  data() {
    return {

    };
  },
  components: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    test() {
        
    },
  }
};
</script>
<style scoped lang='scss'>
</style>
